import React from "react";
import BottomBarNavigationItem from "./BottomBarNavigationItem.js";
import { useDispatch } from "react-redux";
import { MenuActionCreators } from "../../../redux/action-creators/index.js";

const AZSportsBottomBarNavigationItem = () => {
  const dispatch = useDispatch();

  const onAZSportsClick = () => {
    dispatch(MenuActionCreators.showQuickLinksInnerMenu());
  };

  return (
    <BottomBarNavigationItem
      onClick={onAZSportsClick}
      iconColor={"white"}
      iconLabel={"az-sports"}
      dataTestId={"bottom-navigation-az-sports"}
      googleAnalyticsLabel={"AZ-Sports"}
    >
      <span>Sports A-Z</span>
    </BottomBarNavigationItem>
  );
};

export default React.memo(AZSportsBottomBarNavigationItem);

AZSportsBottomBarNavigationItem.propTypes = {};
